export interface FAQItem {
  id: string
  category: string
  question: string
  answer: string
  popular?: boolean
}

export const faqCategories = [
  { id: 'productos', name: 'Productos y Nutrición', icon: 'Package' },
  { id: 'pedidos', name: 'Pedidos y Envíos', icon: 'Truck' },
  { id: 'suscripciones', name: 'Suscripciones', icon: 'RefreshCw' },
  { id: 'calidad', name: 'Calidad y Seguridad', icon: 'ShieldCheck' },
  { id: 'cuenta', name: 'Mi Cuenta', icon: 'User' },
  { id: 'devoluciones', name: 'Devoluciones y Garantía', icon: 'RotateCcw' },
]

export const faqItems: FAQItem[] = [
  // PRODUCTOS Y NUTRICIÓN
  {
    id: 'faq-1',
    category: 'productos',
    question: '¿Cómo sé qué alimento es el adecuado para mi mascota?',
    answer:
      'Cada mascota es única. Recomendamos considerar: edad (cachorro, adulto, senior), nivel de actividad, sensibilidades alimentarias, y condiciones de salud específicas. Nuestro equipo veterinario ofrece asesoramiento personalizado gratuito. Puedes usar nuestra calculadora nutricional online o contactarnos directamente. También ofrecemos packs de prueba de 2kg para que tu mascota pueda probar antes de comprometerte con un saco grande.',
    popular: true,
  },
  {
    id: 'faq-2',
    category: 'productos',
    question: '¿Qué significa "Human Grade" en vuestros productos?',
    answer:
      'Human Grade significa que todos nuestros ingredientes son aptos para consumo humano y procesados en instalaciones certificadas para alimentación humana. No utilizamos subproductos cárnicos, harinas de origen desconocido ni ingredientes de calidad inferior. Es el mismo pollo, salmón o ternera que encontrarías en tu supermercado, simplemente preparado específicamente para las necesidades nutricionales de perros y gatos.',
    popular: true,
  },
  {
    id: 'faq-3',
    category: 'productos',
    question: '¿Cómo hago la transición del alimento anterior a Petiora?',
    answer:
      'La transición debe ser gradual durante 7-10 días para evitar molestias digestivas:\n\nDías 1-2: 25% Petiora + 75% alimento anterior\nDías 3-4: 50% Petiora + 50% alimento anterior\nDías 5-6: 75% Petiora + 25% alimento anterior\nDía 7+: 100% Petiora\n\nPara mascotas con estómagos muy sensibles, recomendamos extender la transición a 14 días. Incluimos una guía detallada en cada pedido.',
    popular: false,
  },
  {
    id: 'faq-4',
    category: 'productos',
    question: '¿Vuestros productos son aptos para mascotas con alergias?',
    answer:
      'Sí. Ofrecemos varias opciones hipoalergénicas: fórmulas monoproteicas (una sola fuente de proteína animal), grain-free (sin cereales), y opciones con proteínas novel (conejo, pato, venado) para mascotas con alergias múltiples. Todos nuestros productos están libres de los alérgenos más comunes: soja, maíz, trigo, colorantes y conservantes artificiales. Consulta con nuestro equipo veterinario para encontrar la mejor opción para tu caso específico.',
    popular: true,
  },
  {
    id: 'faq-5',
    category: 'productos',
    question: '¿Cuánto tiempo dura el alimento una vez abierto?',
    answer:
      'El alimento seco se mantiene fresco durante 6-8 semanas después de abrir el saco, siempre que se almacene correctamente: en lugar fresco y seco, con el saco bien cerrado (recomendamos usar pinzas herméticas o transferir a un contenedor hermético). El alimento húmedo debe consumirse en 24-48 horas una vez abierto y conservarse en el frigorífico. Nuestros envases incluyen fecha de caducidad y número de lote para máxima trazabilidad.',
    popular: false,
  },
  {
    id: 'faq-6',
    category: 'productos',
    question: '¿Puedo mezclar alimento seco y húmedo?',
    answer:
      'Absolutamente. De hecho, es una excelente forma de aumentar la hidratación (especialmente importante en gatos) y hacer las comidas más apetecibles. Recomendamos usar el alimento húmedo como "topper" (25-30% de la ración) sobre el seco. Ajusta las cantidades para no exceder las calorías diarias recomendadas. Nuestra calculadora nutricional online puede ayudarte a calcular las proporciones exactas según el peso y actividad de tu mascota.',
    popular: false,
  },
  {
    id: 'faq-7',
    category: 'productos',
    question:
      '¿Qué diferencia hay entre vuestro alimento y las marcas de supermercado?',
    answer:
      'Las diferencias clave son:\n\n1. Ingredientes: Usamos carne fresca real (40-50%) vs. harinas y subproductos\n2. Calidad: Human Grade vs. Feed Grade\n3. Procesamiento: Cocción suave a baja temperatura vs. extrusión de alta temperatura\n4. Sin rellenos: Cero maíz, trigo o soja como relleno barato\n5. Transparencia: Trazabilidad completa de cada ingrediente\n6. Formulación: Diseñada por veterinarios nutricionistas vs. formulación genérica\n\nEl resultado: mejor digestibilidad, heces más pequeñas y firmes, pelaje más brillante, y salud a largo plazo.',
    popular: true,
  },

  // PEDIDOS Y ENVÍOS
  {
    id: 'faq-8',
    category: 'pedidos',
    question: '¿Cuánto tarda en llegar mi pedido?',
    answer:
      'Envío estándar: 24-48 horas laborables en península. Baleares: 48-72 horas. Canarias, Ceuta y Melilla: 3-5 días laborables. Los pedidos realizados antes de las 14:00h se procesan el mismo día. Recibirás un email con el número de seguimiento en cuanto tu pedido salga de nuestro almacén. Ofrecemos envío express (24h garantizado) por un suplemento de 4,95€.',
    popular: true,
  },
  {
    id: 'faq-9',
    category: 'pedidos',
    question: '¿Cuánto cuesta el envío?',
    answer:
      'Envío GRATIS en pedidos superiores a 49€ en península. Por debajo de 49€: 3,95€. Baleares: envío gratis a partir de 69€, por debajo 5,95€. Canarias, Ceuta y Melilla: consultar tarifas (envío bonificado en suscripciones). Los suscriptores de Petiora+ disfrutan de envío gratis en todos sus pedidos automáticos, sin mínimo.',
    popular: true,
  },
  {
    id: 'faq-10',
    category: 'pedidos',
    question:
      '¿Puedo cambiar la dirección de entrega después de hacer el pedido?',
    answer:
      'Sí, pero solo si el pedido aún no ha sido enviado. Contacta con nuestro servicio de atención al cliente lo antes posible (chat, email o teléfono). Una vez que el pedido está en tránsito con la agencia de transporte, no podemos modificar la dirección, pero puedes contactar directamente con la agencia usando tu número de seguimiento.',
    popular: false,
  },
  {
    id: 'faq-11',
    category: 'pedidos',
    question: '¿Qué hago si mi pedido llega dañado o incompleto?',
    answer:
      'Lamentamos mucho cualquier incidencia. Por favor:\n\n1. Haz fotos del paquete dañado y del contenido\n2. Contacta con nosotros en las 48 horas siguientes a la recepción\n3. Te enviaremos un reemplazo inmediato sin coste\n\nNo es necesario devolver el producto dañado. Tu satisfacción es nuestra prioridad y gestionamos todas las incidencias con la máxima rapidez.',
    popular: false,
  },
  {
    id: 'faq-12',
    category: 'pedidos',
    question: '¿Hacéis envíos internacionales?',
    answer:
      'Actualmente solo enviamos a España (península, Baleares, Canarias, Ceuta y Melilla) y Portugal. Estamos trabajando para expandir nuestros envíos a otros países de la UE próximamente. Si estás interesado en recibir nuestros productos en otro país, déjanos tu email y te avisaremos cuando esté disponible.',
    popular: false,
  },

  // SUSCRIPCIONES
  {
    id: 'faq-13',
    category: 'suscripciones',
    question: '¿Cómo funciona la suscripción Petiora+?',
    answer:
      'Es muy sencillo:\n\n1. Elige tus productos y frecuencia de entrega (cada 2, 3 o 4 semanas)\n2. Recibe automáticamente tu pedido sin tener que acordarte\n3. Ahorra un 15% en cada envío + envío gratis siempre\n4. Modifica, pausa o cancela cuando quieras desde tu cuenta\n\nSin permanencia, sin letra pequeña. Tú tienes el control total.',
    popular: true,
  },
  {
    id: 'faq-14',
    category: 'suscripciones',
    question: '¿Puedo pausar o cancelar mi suscripción en cualquier momento?',
    answer:
      'Sí, absolutamente. Sin penalizaciones ni preguntas incómodas. Puedes pausar tu suscripción hasta 3 meses, cancelarla definitivamente, o simplemente saltar un envío puntual. Todo desde tu panel de control en "Mi Cuenta" con un solo clic. También puedes contactar con nuestro equipo si prefieres que lo hagamos nosotros.',
    popular: true,
  },
  {
    id: 'faq-15',
    category: 'suscripciones',
    question: '¿Puedo cambiar los productos de mi suscripción?',
    answer:
      'Por supuesto. Puedes añadir, quitar o cambiar productos en cualquier momento. Los cambios se aplicarán al siguiente envío. Si necesitas cambiar algo para el envío actual, contacta con nosotros antes de la fecha de procesamiento (te avisamos por email 3 días antes de cada envío).',
    popular: false,
  },
  {
    id: 'faq-16',
    category: 'suscripciones',
    question: '¿Qué pasa si me voy de vacaciones?',
    answer:
      'Simplemente pausa tu suscripción desde tu cuenta o adelanta/retrasa la fecha del próximo envío. Muchos clientes adelantan el envío antes de irse de vacaciones para tener stock suficiente, o lo pausan si tienen a alguien cuidando de su mascota con otro alimento. Flexibilidad total para adaptarse a tu vida.',
    popular: false,
  },

  // CALIDAD Y SEGURIDAD
  {
    id: 'faq-17',
    category: 'calidad',
    question: '¿Dónde se fabrican vuestros productos?',
    answer:
      'Todos nuestros productos se fabrican en España, en instalaciones certificadas con los más altos estándares de calidad (FEDIAF, IFS Food, BRC). Trabajamos con proveedores locales de confianza para los ingredientes frescos, reduciendo la huella de carbono y garantizando la máxima frescura. Cada lote tiene trazabilidad completa: puedes saber exactamente de dónde viene cada ingrediente.',
    popular: true,
  },
  {
    id: 'faq-18',
    category: 'calidad',
    question: '¿Qué certificaciones tienen vuestros productos?',
    answer:
      'Nuestros productos cuentan con:\n\n- FEDIAF Compliant (estándar europeo de nutrición animal)\n- Human Grade Ingredients (ingredientes aptos para consumo humano)\n- IFS Food (seguridad alimentaria)\n- Certificación Km 0 (ingredientes locales)\n- MSC (pesca sostenible en productos con pescado)\n- Carbon Neutral (huella de carbono compensada)\n\nTodas las certificaciones están disponibles en nuestra página de transparencia.',
    popular: false,
  },
  {
    id: 'faq-19',
    category: 'calidad',
    question: '¿Hacéis pruebas en animales?',
    answer:
      'NO realizamos pruebas invasivas ni experimentación animal. Nuestras fórmulas se desarrollan mediante:\n\n1. Análisis nutricional en laboratorio\n2. Estudios de palatabilidad voluntarios (mascotas de nuestro equipo y voluntarios)\n3. Seguimiento de resultados reales con clientes\n\nNunca sometemos a ningún animal a pruebas dolorosas o estresantes. Nuestra filosofía es el bienestar animal en primer lugar.',
    popular: false,
  },
  {
    id: 'faq-20',
    category: 'calidad',
    question: '¿Cómo garantizáis la frescura del producto?',
    answer:
      'Múltiples medidas:\n\n1. Producción en lotes pequeños y frecuentes (no almacenamos stock antiguo)\n2. Envasado en atmósfera protectora\n3. Fecha de caducidad mínima de 12 meses en el momento del envío\n4. Almacenamiento en condiciones óptimas (temperatura y humedad controladas)\n5. Rotación FIFO (First In, First Out)\n\nCada saco incluye fecha de fabricación y caducidad claramente visible.',
    popular: false,
  },

  // MI CUENTA
  {
    id: 'faq-21',
    category: 'cuenta',
    question: '¿Cómo creo una cuenta?',
    answer:
      'Puedes crear una cuenta durante el proceso de compra o en cualquier momento desde "Mi Cuenta". Solo necesitas un email y contraseña. Con una cuenta puedes: guardar direcciones, ver tu historial de pedidos, gestionar suscripciones, acumular puntos de fidelidad, y recibir recomendaciones personalizadas. También puedes comprar como invitado sin crear cuenta.',
    popular: false,
  },
  {
    id: 'faq-22',
    category: 'cuenta',
    question: '¿Tenéis programa de fidelidad?',
    answer:
      'Sí, Petiora Rewards. Por cada euro gastado acumulas 1 punto. 100 puntos = 5€ de descuento. Además:\n\n- Bienvenida: 200 puntos al crear cuenta\n- Cumpleaños de tu mascota: 500 puntos\n- Reseña con foto: 100 puntos\n- Referir un amigo: 1000 puntos (para ambos)\n\nLos puntos no caducan y puedes canjearlos cuando quieras.',
    popular: true,
  },
  {
    id: 'faq-23',
    category: 'cuenta',
    question: '¿Puedo tener varias mascotas en mi perfil?',
    answer:
      'Sí, puedes añadir perfiles ilimitados de mascotas. Para cada una puedes guardar: nombre, edad, raza, peso, condiciones de salud, preferencias alimentarias. Esto nos permite darte recomendaciones personalizadas y calcular las raciones exactas para cada una. También recibirás recordatorios útiles (vacunas, desparasitaciones, etc.).',
    popular: false,
  },

  // DEVOLUCIONES Y GARANTÍA
  {
    id: 'faq-24',
    category: 'devoluciones',
    question: '¿Cuál es vuestra política de devoluciones?',
    answer:
      'Garantía de satisfacción 30 días. Si tu mascota no le gusta el producto o no ves resultados, te devolvemos el 100% del dinero, incluso si el saco está abierto. Solo tienes que contactarnos y te enviaremos una etiqueta de devolución prepagada. No hacemos preguntas incómodas. Queremos que estés completamente satisfecho.',
    popular: true,
  },
  {
    id: 'faq-25',
    category: 'devoluciones',
    question: '¿Qué hago si mi mascota no acepta el nuevo alimento?',
    answer:
      'Primero, asegúrate de hacer la transición gradual (7-10 días). Si aún así no lo acepta:\n\n1. Contacta con nuestro equipo veterinario para consejos de palatabilidad\n2. Podemos enviarte muestras de otras fórmulas sin coste\n3. Si definitivamente no funciona, devolución completa garantizada\n\nTambién ofrecemos packs de prueba de 2kg para minimizar el riesgo antes de comprar un saco grande.',
    popular: true,
  },
  {
    id: 'faq-26',
    category: 'devoluciones',
    question: '¿Cuánto tarda el reembolso?',
    answer:
      'Una vez recibamos tu devolución (o confirmes la incidencia si es producto defectuoso), procesamos el reembolso en 24-48 horas laborables. El dinero aparecerá en tu cuenta bancaria en 3-5 días laborables dependiendo de tu banco. Te enviaremos un email de confirmación cuando el reembolso esté procesado.',
    popular: false,
  },
  {
    id: 'faq-27',
    category: 'devoluciones',
    question: '¿Qué pasa si el producto llega caducado o en mal estado?',
    answer:
      'Esto es extremadamente raro debido a nuestros controles de calidad, pero si ocurre:\n\n1. Haz una foto del producto y la fecha de caducidad\n2. Contacta con nosotros inmediatamente\n3. Te enviamos reemplazo urgente (24h) sin coste\n4. No es necesario devolver el producto defectuoso\n\nTu mascota no debe quedarse sin comida por un error nuestro. Priorizamos tu tranquilidad.',
    popular: false,
  },
]

export function getFAQByCategory(category: string): FAQItem[] {
  return faqItems.filter((item) => item.category === category)
}

export function getPopularFAQs(): FAQItem[] {
  return faqItems.filter((item) => item.popular)
}

export function searchFAQ(query: string): FAQItem[] {
  const lowerQuery = query.toLowerCase()
  return faqItems.filter(
    (item) =>
      item.question.toLowerCase().includes(lowerQuery) ||
      item.answer.toLowerCase().includes(lowerQuery),
  )
}
